

















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
export default defineComponent({
  name: "MessageThreadsHideConfirm",
  components: {
    BaseButton,
    BaseConfirm,
  },
  props: {
    show: { type: Boolean, required: true },
    thread: { type: Object as PropType<MessageThread | null> },
    deleteCompletely: { type: Boolean, required: true },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const opponentScreenName = computed(() => props.thread?.users.find(i => i.id !== authUser.value?.id)?.screenName);
    const actionTitle = computed(() => (props.deleteCompletely ? $t("Delete") : $t("Hide")));
    const confirmTitle = computed(() => $t("{0} thread with {1}?", [actionTitle.value, opponentScreenName.value]));
    return {
      confirmTitle,
      actionTitle,
    };
  },
});
